module.exports = __webpack_public_path__ + "img/85.51f0387f.svg";